import { AboutPanelContent } from "../AboutPanel/AboutPanel";

interface Props {
  children: React.ReactNode;
}

export const OverviewContentWrapper = ({ children }: Props) => {
  return (
    <div>
      {children}
      <AboutPanelContent />
    </div>
  );
};
